'use client';

import { ExperimentProvider as CarvanaExperimentProvider } from '@carvana/experiment';
import React from 'react';
import { settings } from '~/constants/common/experiments';
import { type PropsFromServer } from '~/context/common/ExperimentProvider';
import { Experiments } from '~/contracts/common';
import useExperimentsWithIdentifiers from '~/hooks/common/experiments/useExperimentsWithIdentifiers';

type OwnProps = React.PropsWithChildren<
  Pick<PropsFromServer, 'experiments' | 'serverCookies'> &
    Partial<Pick<PropsFromServer, 'browserCookieId' | 'userId'>> & {
      browserCookieIdExperiments?: Partial<Experiments>;
      userIdExperiments?: Partial<Experiments>;
    }
>;

export default function SrpExperimentProvider({
  browserCookieId = '',
  browserCookieIdExperiments = {},
  children,
  experiments,
  serverCookies,
  userId = '',
  userIdExperiments = {}
}: OwnProps) {
  const experimentsWithIdentifiers = useExperimentsWithIdentifiers({
    browserCookieId,
    browserCookieIdExperiments,
    userId,
    userIdExperiments
  });

  return (
    <CarvanaExperimentProvider
      defaults={settings}
      onPageLoadExperiments={experimentsWithIdentifiers}
      preloadedExperiments={experiments}
      serverCookies={serverCookies}
    >
      {children}
    </CarvanaExperimentProvider>
  );
}

type ConditionalProps = React.PropsWithChildren<{
  experimentContext?: PropsFromServer;
}>;

// To support using SearchProviders in both routers, we conditionally render
// ExperimentProvider based on the presence of experimentContext
// props which is still provided by pages router getProps
export function ConditionalSrpExperimentProvider({
  children,
  experimentContext
}: ConditionalProps) {
  return experimentContext ? (
    <SrpExperimentProvider {...experimentContext}>
      {children}
    </SrpExperimentProvider>
  ) : (
    <>{children}</>
  );
}
